const dev = '_DEV';
const production = '';

export const env = production;
export const emailEnv = '';
export const url = env === dev ? 'http://localhost:8089/' : 'https://iclimb.io/';
export const backendServicesUrl = '/backend/services/';
// FIRMS row that is Summit itself ("Summit RE"); backend: SUMMIT_FIRM_ID
export const summitFirmId = env === dev ? '2' : '8663';

